/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import {
	Login,
	AuthProvider,
	AuthMachine,
	Loading,
	getIsNaniClubEnabled,
	redirectToNaniClubLogin,
} from "common-components";
import { UiLoginPage } from "./LoginPage.style";

const { useAuthState } = AuthProvider;
const { state: AuthStates } = AuthMachine;

/**
 * 登入頁面
 *
 * nani 網域不顯示這頁，直接整頁導去 Nani Club 授權頁；
 * oneclass 網域維持原本的帳密登入。
 *
 * 只有 Idle 才外導。新會員從 Nani Club 回來時會停在 ReadySettingEducation 並被落點頁導來這頁，
 * 選學制的畫面就在 Login 元件裡（用 result.isNewMember 切換渲染），這時外導會讓他永遠選不到學制。
 */

export const LoginPage = () => {
	const authState = useAuthState();
	const shouldRedirectToNaniClub = getIsNaniClubEnabled() && authState.matches(AuthStates.Idle);

	useEffect(() => {
		if (shouldRedirectToNaniClub) redirectToNaniClubLogin();
	}, [shouldRedirectToNaniClub]);

	if (shouldRedirectToNaniClub) {
		return (
			<UiLoginPage>
				<Loading />
			</UiLoginPage>
		);
	}

	return (
		<UiLoginPage>
			<Login />
		</UiLoginPage>
	);
};
